"use client";

import { useWishlistStore } from "@/lib/store/useWishlistStore";
import { Heart } from "lucide-react";
import { useState, useEffect } from "react";

interface WishlistButtonProps {
  product: {
    id: string;
    name: string;
    price: number;
    slug: string;
    image?: string | null;
  };
  variant?: "icon" | "full";
  onToggle?: (isFavorite: boolean) => void;
}

export default function WishlistButton({ product, variant = "icon", onToggle }: WishlistButtonProps) {
  const { toggleItem, isInWishlist } = useWishlistStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const isFavorite = isInWishlist(product.id);

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleItem(product);
    if (onToggle) onToggle(!isFavorite);
  };

  if (variant === "full") {
    return (
      <button
        onClick={handleToggle}
        className={`flex-1 py-5 border flex items-center justify-center gap-3 font-bold uppercase tracking-[0.2em] text-xs transition-all ${
          isFavorite 
            ? "bg-[#F4F0E8] border-[#F4F0E8] text-black" 
            : "border-[rgba(201,168,76,0.2)] text-[#7A7670] hover:border-[#C9A84C] hover:text-[#C9A84C]"
        }`}
      >
        <Heart size={18} fill={isFavorite ? "currentColor" : "none"} />
        {isFavorite ? "Favorilerde" : "Favorilere Ekle"}
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleItem(product);
      }}
      className={`absolute top-4 right-4 z-20 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
        isFavorite 
          ? "bg-[#C9A84C] text-black shadow-lg" 
          : "bg-black/20 text-white hover:bg-white hover:text-black border border-white/10"
      }`}
    >
      <Heart size={16} fill={isFavorite ? "currentColor" : "none"} />
    </button>
  );
}
